var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',{attrs:{"title":"Pie Chart"}},[[_c('e-charts',{ref:"pie",attrs:{"autoresize":"","options":_vm.pie,"auto-resize":""}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }